import messages from '@bicstone/ra-language-japanese';

export const japaneseMessages = {
  ...messages,
  ra: {
    ...messages.ra,
    sort: {
      //リストソートの翻訳が誤っている為上書き
      ASC: '降順',
      DESC: '昇順',
      sort_by: '%{field} で%{order}に並び替え'
    },
    action: {
      ...messages.ra.action,
      copy: 'コピー'
    },
    message: {
      ...messages.ra.message,
      copied: 'コピーしました'
    }
  },
  Role: '',
  resources: {
    accounts: {
      name: 'スタッフ管理',
      fields: {
        id: 'ID',
        name: '名前',
        email: 'メールアドレス',
        authority: '権限',
        accountInvalidFlag: 'アカウントステータス',
        lastLoginDate: '最終利用日時'
      }
    },
    invitations: {
      name: 'パートナー招待',
      fields: {
        id: 'ID',
        inviteName: '被招待者',
        inviteEmail: 'メールアドレス',
        inviteStatus: 'ステータス',
        name: '被招待者名',
        email: 'メールアドレス',
        partnerReward: '報酬割合',
        introducerReward: '紹介報酬',
        parentPartner: '親パートナー'
      }
    },
    affiliates: {
      name: 'パートナー管理',
      fields: {
        id: 'アフィリエイトID',
        affiliateUrl: '紹介リンク',
        partnerId: 'パートナーID',
        partnerClass: 'パートナー種別',
        parentPartner: '1次パートナー名称',
        postUrl: '使用WEBサイトURL',
        applyStatus: '承認状況',
        expirationDate: '契約終了日',
        partnerReward: 'パートナー報酬',
        introducerReward: '紹介報酬',
        invalidFlag: 'アフィリエイトステータス',
        accountInvalidFlag: 'アカウントステータス',
        memo: '備考',
        partnerType: 'アカウント種別',
        name: 'パートナー登録名',
        lastName: '姓',
        firstName: '名',
        email: 'パートナーメールアドレス',
        tel: 'パートナー電話番号',
        mobilePhone: '携帯電話番号',
        address: '住所',
        zipCode: '郵便番号',
        prefecture: '都道府県',
        city: '市区町村',
        address1: '番地',
        address2: 'ビル名 部屋番号',
        invoiceNumber: 'インボイス登録番号',
        frontImage: '身分証明書 表面',
        backImage: '身分証明書 裏面',
        dunsNumber: 'D-U-N-S番号',
        website: 'Webサイト',
        coupon: 'クーポンコード',
        createdAt: '申請日時',
        approvalStatusChangedAt: '承認日時',
        approvalStatusChanger: '承認者',
        rewardPeriod: '報酬期間'
      }
    },
    orders: {
      name: '注文管理',
      fields: {
        clientId: 'ECサイト',
        orderId: 'ECサイト注文ID',
        ecSiteClientId: 'ECサイト顧客ID',
        affiliateId: 'アフィリエイトID',
        partnerName: 'パートナー名',
        partnerId: 'パートナーID',
        orderDate: '注文日時',
        price: '価格(税抜)',
        reward: 'パートナー報酬額',
        isCancelled: 'キャンセル',
        hasCoupon: 'クーポン利用',
        orderDate_start: '注文日（開始）',
        orderDate_end: '注文日（終了）',
        approvedAt: '承認日時',
        disapprovalReasonCode: '否認理由',
        disapprovalReason: '否認理由詳細',
        approvalStatus: '状態',
        lastStatusChangedAt: '状態更新日時',
        lastStatusChanger: '更新者',
        pending: '保留中',
        approved: '承認済み',
        denied: '否認済み',
        remainingPeriod: '残承認猶予期間',
        productId: '商品ID',
        productName: '商品名',
        quantity: '数量',
        productSubtotal: '商品小計(税抜)',
        productReward: '合計報酬率',
        productRewardPrice: '報酬額',
        isExistingCustomer: '既存顧客',
        usageCount: '購入回数',
        basePartnerReward: '基本報酬率',
        campaignRewardDelta: 'キャンペーン報酬加算',
        usageCountRewardDelta: '購入回数報酬加算',
        existingCustomerRewardDelta: '既存顧客報酬減算',
        isExclude: '報酬除外',
        fuid: 'successfee購入者ID'
      }
    },
    buyers: {
      name: '購入者管理',
      fields: {
        no: 'No',
        clientName: 'ショップ名',
        affiliateId: 'アフィリエイトID',
        partnerName: 'パートナー名',
        ecSiteClientId: 'ECサイト顧客ID',
        fuid: 'successfee購入者ID',
        rewardPeriodDisplay: '有効期間',
        paymentStartDate: '支払期間開始日',
        paymentEndDate: '支払期間終了日',
        purchaseCount: '購入回数',
        totalSales: '累積売上',
        totalReward: '累積報酬額',
        status: 'ステータス',
        active: '有効',
        inactive: '無効'
      }
    },
    sales: {
      name: {
        sales: 'アナリティクス',
        all: '全体',
        clients: 'ECサイト別',
        partners: 'パートナー別'
      },
      fields: {
        totalSalesAmount: 'successfee経由総売上',
        totalFeebackCommission: 'successfee手数料',
        totalIntroducerCommission: '紹介報酬額',
        totalAffiliateCommission: 'パートナー支払い額',
        totalPendingAmount: 'パートナー未確定報酬額',
        activeBuyerCount: '累積顧客数',
        totalSalesCount: '売上件数',
        totalClickCount: '総訪問数',
        startDate: '開始日',
        startMonth: '開始月',
        endDate: '終了日',
        endMonth: '終了月',
        selectClient: 'ECサイト選択',
        selectPartner: 'パートナー選択',
        granularity: '粒度',
        graphTarget: 'グラフ対象選択',
        resultType: '内訳対象選択',
        date: '日付',
        details: '売上と件数の内訳',
        downloadCSV: 'CSVダウンロード',
        salesAmount: '売上高',
        salesAmountRate: '売上割合',
        adjustedSalesAmount: '差引金額',
        feebackCommission: 'successfee手数料',
        negativeFeebackCommission: 'successfee手数料',                
        partnerCommission: 'パートナー支払い額',
        introducerCommission: '紹介報酬額',
        affiliateCommission: 'パートナー支払い額',
        negativeAffiliateCommission: 'パートナー支払い額',
        salesCount: '売上件数',
        clickCount: '訪問数'
      }
    },
    invoices: {
      name: '支払い管理',
      fields: {
        issueDate: '発行日',
        invoiceNumber: '請求書番号',
        salesStartDate: '売上開始日時',
        salesEndDate: '売上終了日時',
        subTotal: '小計',
        salesTax: '消費税',
        totalAmount: '合計金額（税込）',
        status: '支払いステータス',
        paymentDeadline: '振込期日',
        invoiceMemo: '備考',
        detailPageLink: '詳細リンク',
        invoicePdf: '請求書',
        receiptPdf: '領収書',
        invoiceDetailPdf: '明細をダウンロード'
      }
    },
    'partner-payments': {
      name: '報酬の支払状況',
      fields: {
        paymentDate: '支払予定日',
        totalPaymentAmount: '支払合計金額',
        partnerName: 'パートナー名',
        amount: '今回確定分',
        carryoverAmount: '繰越金額',
        administrativeFee: '振込手数料',
        totalAmount: '支払金額',
        pendingAmount: '保留金額',
        paymentStatus: 'アフィリエイトステータス',
        memo: 'メモ'
      }
    },
    settings: {
      name: '設定',
      fields: {
        name: '登録名',
        nameKana: '登録名カナ',
        companyName: '会社名',
        companyNameKana: '会社名カナ',
        representative: '代表者名',
        representativeKana: '代表者名カナ',
        email: 'メールアドレス',
        tel: '電話番号',
        zipCode: '郵便番号',
        address: '住所',
        prefecture: '都道府県',
        city: '市区町村',
        address1: '番地',
        address2: 'ビル名 部屋番号',
        bankNumber: '銀行番号',
        bankName: '銀行名',
        bankBranchNumber: '支店番号',
        bankBranchName: '支店名',
        bankAccountType: '口座種別',
        bankAccountNumber: '口座番号',
        bankAccountName: '受取人名',
        ecSiteUrl: 'ECサイトURL',
        ecSiteType: 'ECサイトタイプ',
        ecSiteCategoryType: 'ECサイトカテゴリ',
        agency: '取次店',
        invoiceNumber: 'インボイス登録番号',
        ecSiteContactEmail: 'お問い合わせ先メールアドレス',
        closingDate: '締め日',
        invoiceDate: '請求日',
        plannedPaymentMonth: '支払い予定月',
        plannedPaymentDate: '支払い予定日',
        defaultPartnerReward: 'パートナー報酬(デフォルト)',
        inviteCodeUrl: 'パートナー招待URL',
        partnerLoginUrl: 'パートナーログインURL',
        autoApproval: '自動承認',
        autoDisapproval: '自動否認',
        terms: '利用規約',
        contract: 'パートナー契約',
        autoOrderApprovalFlag: '自動注文承認設定',
        orderApprovalGracePeriod: '注文承認猶予期間',
        existingCustomerDiscountRate: '既存顧客減算率'
      }
    },
    'client-url': {
      name: 'ECサイトURL',
      fields: {
        ecSiteUrl: 'ECサイトURL'
      }
    },
    'usage-count-reward-rates': {
      name: '注文回数による報酬率ルール設定',
      actions: {
        create: '注文回数による報酬率設定の作成',
        edit: '注文回数による報酬率設定の編集',
      },
      fields: {
        usageCount: '注文回数',
        rewardRateDelta: '追加・削減報酬率'
      }
    },
    'product-reward-settings': {
      name: 'キャンペーン対象商品',
      actions: {
        create: 'キャンペーン対象商品を作成',
        'create-exclusion': '報酬除外商品を作成'
      },
      fields: {
        productId: '商品ID',
        productName: 'キャンペーン対象商品',
        productNameExclusion: '商品名',
        campaign: 'キャンペーン対象商品',
        exclusion: '報酬除外商品',
        category: 'カテゴリー',
        productUrl: '商品ページURL',
        productReward: '追加報酬率',
        productRewardExclusion: '報酬率',
        couponCode: '商品専用クーポンコード',
        productImage: '商品画像',
        operationStartDate: '運用開始日',
        operationEndDate: '運用終了日',
        invalidFlag: '有効フラグ'
      }
    },
    notifications: {
      name: 'お知らせ',
      fields: {
        id: 'お知らせID',
        title: 'タイトル',
        message: '本文',
        link: 'リンク',
        type: '種類',
        visibled: '表示',
        publishedAt: '公開開始日時',
        expiresAt: '公開終了日時'
      }
    },
    'client-pr': {
      name: 'ショップ情報',
      fields: {
        approvalConditions: '承認条件',
        approvalConditionsUpdatedAt: '承認条件 最終更新日',
        disapprovalConditions: '否認条件',
        disapprovalConditionsUpdatedAt: '否認条件 最終更新日',
        shopInformation: 'ショップ情報',
        shopInformationUpdatedAt: 'ショップ情報 最終更新日'
      }
    },
    'client-pr-images': {
      name: '利用可能イメージ',
      fields: {
        availableImages: '利用可能イメージをアップロード'
      }
    },
    'terms-settings': {
      name: '利用規約',
      fields: {
        contents: '利用規約',
        agreement: '再同意を求める',
        agreementDeadlineAt: '同意期限',
        agreementChangeWarningText:
          '利用規約を変更すると現在契約中のパートナーに対して利用規約変更の通知が送られます。\n変更を行うと、パートナーは再度利用規約に同意を行う必要があります。',
        dialogTitle: '利用規約変更確認'
      }
    },
    'contract-settings': {
      name: 'パートナー契約',
      fields: {
        contents: 'パートナー契約',
        agreement: '再同意を求める',
        agreementDeadlineAt: '同意期限',
        agreementChangeWarningText:
          'パートナー契約を変更すると現在契約中のパートナーに対してパートナー契約変更の通知が送られます。\n変更を行うと、パートナーは再度パートナー契約に同意を行う必要があります。',
        dialogTitle: 'パートナー契約変更確認'
      }
    },
    contracts: {
      name: '契約内容'
    },
    'script-settings': {
      name: 'API連携設定',
      fields: {}
    },
    registers: {
      name: {
        Terms: '利用規約',
        Contract: '契約内容',
        Form: '必要事項入力',
        FormBasicInput: '基本情報入力',
        FormStoreInformation: 'ストア情報入力',
        Confirmation: '入力内容確認',
        ConfirmRegistrationDetails: '登録内容の確認',
        Verification: '審査',
        ReviewApplication: '審査申請完了',
        Completion: '登録申請完了',
        Identification: '本人確認',
        Conditions: '利用規約',
        CreateStaff: 'パスワード登録',
        Upload: '身分証明書提出',
        SMSAuth: 'SMS認証',
        Error: 'エラー'
      },
      fields: {
        partnerType: 'アカウント種別',
        name: '登録名',
        nameKana: '登録名カナ',
        companyName: '会社名',
        companyNameKana: '会社名カナ',
        representative: '代表者名',
        representativeKana: '代表者名カナ',
        lastName: '姓',
        firstName: '名',
        zipCode: '郵便番号',
        address: '住所',
        prefecture: '都道府県',
        city: '市区町村',
        address1: '番地',
        address2: 'ビル名 部屋番号など',
        tel: '電話番号',
        email: 'メールアドレス',
        emailConfirm: 'メールアドレス(確認)',
        bankNumber: '銀行番号',
        bankName: '銀行名',
        bankBranchNumber: '支店番号',
        bankBranchName: '支店名',
        bankAccountType: '口座種類',
        bankAccountNumber: '口座番号',
        bankAccountName: '口座名義',
        invoiceNumber: 'インボイス登録番号',
        dunsNumber: 'D-U-N-S番号',
        website: 'Webサイト',
        ecSiteType: 'ECサイトタイプ',
        ecSiteUrl: 'ECサイトURL',
        ecSiteCategoryType: 'ECサイトカテゴリ',
        agency: '取次店',
        storeLogoThumbnail: 'ストアロゴ画像',
        bannerImage: 'バナー画像',
        frontImage: '身分証明書 表画像',
        backImage: '身分証明書 裏画像',
        userName: '初期ユーザー名',
        userEmail: '初期ユーザーのメールアドレス',
        userPassword: 'パスワード',
        userPasswordConfirm: 'パスワード確認',
        confirmationCode: '認証番号'
      }
    }
  },
  values: {
    authority: {
      0: 'アカウント保持者',
      1: '管理者',
      2: 'マネージャー',
      3: '経理'
    },
    partnerType: {
      1: '個人',
      2: '会社'
    },
    accountStatus: {
      0: '無効',
      1: '有効',
      2: '仮登録'
    },
    accountInvalidFlag: {
      0: '無効',
      1: '有効',
      2: '仮登録'
    },
    ecSiteType: {
      1: 'Shopify',
      2: 'BASE',
      3: 'STORES',
      4: 'カラーミーショップ',
      5: 'EC-CUBE',
      6: 'futureshop',
      7: 'ショップサーブ',
      8: 'makeshop'
    },
    ecSiteCategoryType: {
      1: '食品・飲料',
      2: 'ファッション・アクセサリー',
      3: '家電・デジタル機器',
      4: 'ホーム＆キッチン',
      5: '生活雑貨・日用品',
      6: '美容・健康',
      7: 'ベビー・キッズ',
      8: 'スポーツ・アウトドア',
      9: 'ペット用品',
      10: '書籍・メディア・ホビー',
      11: '自動車・DIY・産業'
    },
    bankAccountType: {
      1: '普通',
      2: '当座'
    },
    paymentMonth: {
      0: '当月',
      1: '翌月',
      2: '翌々月'
    },
    paymentDate: '%{day}日',
    paymentDateEndOfMonth: '月末',
    'apply-status': {
      1: '未承認',
      2: '申請済み',
      3: '却下'
    },
    clientManagementType: {
      1: '全て',
      2: '個別管理'
    },
    depositStatus: {
      1: '未支払い',
      2: '支払い済み'
    },
    inviteStatus: {
      1: '招待済み',
      2: '申請済み',
      3: '有効期限切れ',
      4: '申請中'
    },
    applyStatus: {
      1: '未承認',
      2: '承認済み',
      3: '却下'
    },
    invalidFlag: {
      0: '無効',
      1: '有効'
    },
    isCancelled: {
      true: '〇',
      false: ''
    },
    hasCoupon: {
      true: '〇',
      false: '✕'
    },
    paymentStatus: {
      1: '支払い不要',
      2: '未振込',
      3: '振込済み',
      4: 'エラー'
    },
    resultTypes: {
      1: '全体',
      2: 'ECストア',
      3: 'パートナー'
      // 4: 'アフィリエイト'
    },
    orderApprovalStatus: {
      0: '保留中',
      1: '承認済み',
      2: '否認済み'
    },
    graphTargetTypes: {
      salesAmount: 'successfee経由総売上',
      feebackCommission: 'successfee手数料',
      partnerCommission: 'パートナー支払い額',
      introducerCommission: '紹介報酬額',
      affiliateCommission: 'パートナー支払い額',
      adjustedSalesAmount: '差引金額',
      salesCount: '売上件数',
      clickCount: '訪問数'
    },
    graphTargetUnits: {
      salesAmount: '円',
      feebackCommission: '円',
      partnerCommission: '円',
      introducerCommission: '円',
      affiliateCommission: '円',
      salesCount: '件',
      clickCount: '回',
      buyerCount: '人'
    }
  },
  'terms-dialog': {
    terms: {
      download: '利用規約をダウンロード',
      aggreement: '利用規約に同意する',
      title: '利用規約が更新されました',
      titleNone: '利用規約',
      deadline: '同意期限 :',
      description: '利用規約が更新されました。引き続きシステムを使用するには再度利用規約の同意を行う必要があります。',
      descriptionForUser:
        '利用規約が更新されました。引き続きシステムを使用するには、アカウントの管理者が再度利用規約の確認し、同意する必要があります。',
      descriptionWarning: '利用規約が更新されました。同意期限までに利用規約の同意を行う必要があります。',
      descriptionWarningForUser:
        '利用規約が更新されました。アカウントの管理者は同意期限までに利用規約の確認し、同意する必要があります。'
    },
    contract: {
      download: '契約内容をダウンロード',
      titleNone: 'パートナー契約',
      descriptionWarning: '以下の内容をご確認の上、同意期限までに同意をお願いします。'
    },
    contractPeriod: {
      title: '契約期間',
      descriptionWarning: '以下の内容をご確認の上、契約を更新してください。',
      download: '契約内容をダウンロード',
      aggreement: '契約を更新する'
    },

    logout: 'ログアウト',
    later: '後で行う',
    ok: 'OK',
    close: '閉じる'
  },
  cognito: {
    Unknown: 'サーバーとの通信に失敗しました。しばらくしてから再度お試しください。',
    MeEndpointException: 'ユーザーの取得に失敗しました。現在アカウントが利用できません。',
    NotAuthorizedException: 'ユーザー名もしくはパスワードが間違っています。',
    UserNotFoundException: 'ユーザーが見つかりません。',
    CodeMismatchException: '認証コードが間違っています。',
    UsernameExistsException: 'すでに同じユーザーが登録されています。',
    InvalidPasswordException:
      'パスワードは大文字、小文字、数字、英字をそれぞれ1文字以上含む8文字以上で設定してください。',
    ExpiredCodeException: '認証コードの有効期限が切れています。',
    LimitExceededException: 'リクエストが制限を超えました。しばらく時間をおいてから再度お試しください。'
  }
};
